module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hrms15e-popup3-desc2",
      "id": "hrms15e-popup3-desc2",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC9']['10']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC9']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setYearOutput(_vm.data.detail.dteyreap)))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC9']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.numtime))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC9']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.kpino))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC9']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.codempid) + " - " + _vm._s(_vm.data.detail.desc_codempid))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC9']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    staticClass: "form-control readonly-field-color",
    attrs: {
      "readonly": ""
    }
  }, [_vm._v(_vm._s(_vm.data.detail.kpiitem))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC9']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    staticClass: "form-control readonly-field-color",
    attrs: {
      "readonly": ""
    }
  }, [_vm._v(_vm._s(_vm.data.detail.target))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC9']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.v_mtrunit))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC9']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.detail.mtrvalue))])])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.detail3InfoDesc2PopupTable,
      "data": _vm.data.table,
      "indexDisp": false,
      "searchDisp": false
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-115f9478!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms15e/popupDetail3InfoDesc2.vue
// module id = 3565
// module chunks = 1